import { Formik, Form } from "formik";

import React from "react";

const HousingPaymentForm = ({ onClose, selectedId, handleSubmission }) => {
  return (
    <Formik
      initialValues={{
        housing_expense: {
          date_of_check: "",
          hp_submission_reimbursement_date: "",
          hp_payment_date: "",
          receipt: null,
        },
      }}
      validationSchema={null}
      onSubmit={(values) => {
        handleSubmission(selectedId, values);
      }}
    >
      <Form className="form-main mt-4">
        <div className="action gap-2">
          <button
            type="button"
            className="secondary-btn w-50"
            onClick={onClose}
          >
            Close
          </button>
          <button type="submit" className="primary-btn w-50 fs-6   small">
            Yes, Approve
          </button>
        </div>
      </Form>
    </Formik>
  );
};

export default HousingPaymentForm;
